import { render, staticRenderFns } from "./ViajesMapa.vue?vue&type=template&id=2a1c3d34"
import script from "./ViajesMapa.vue?vue&type=script&lang=js"
export * from "./ViajesMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports